export default "__VITE_ASSET__BCAQ3LFf__"